<template src="./App.html"></template>
<style lang="scss" src="./App.scss"></style>

<script>


import Rgpd from "@/utils/rgpd";

const default_layout = 'default';
import Vue from "vue";

export default Vue.extend({
  name: 'AirFranceShopping',
  data() {
    return {
      currentLocal: null
    }
  },
  computed: {
    layout() {
      return (this.$route.meta.layout || default_layout) + '-layout';
    },
    locale: {
      get() {
        return this.$store.getters.getCurrentLocale
      }
    }
  }, watch: {
    $route: 'getRoute',
  },
  methods: {
    getRoute() {
      this.currentRoute = this.$route.path
      if (this.$i18n.locale !== this.locale) {
        this.$store.dispatch('setCurrentLocal', {locale: this.$i18n.locale})
        document.getElementsByTagName("html")[0].lang = this.$i18n.locale;
        this.$store.dispatch('getCategoryTree')
      }
    }
  }

});
</script>
